import Vue from "vue";
import JwtService from "@/core/services/jwt.service";
import qs from "qs";

const ApiService = {
  baseUrl: "/api/",
  // baseUrl: "https://easyreceipt-test.thirdchannel.ph/api/",
  //baseUrl: "https://localhost:44330/",
  //baseUrl: "https://omsmpc-test.einvoice.com.ph/api/",
  //baseUrl: "https://omsmpc.einvoice.com.ph/api/",

  getReportHost(){
    var retVal = 'reports.einvoice.com.ph';
    if (location.host.includes('test'))
      retVal = 'reports-test.einvoice.com.ph';
    return retVal;
  },

  testEnvironmentReportsKeySuffix(){
    var retVal = '';
    if (location.host.includes('test'))
      retVal = '_TEST';
    return retVal;
  },

  getToken() {
    return JwtService.getToken();
  },

  query(resource, params) {
    return Vue.axios.get(this.baseUrl + resource, params).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, params, config = null) {
    if (!config) {
      config = {
        headers: { Authorization: `Bearer ${JwtService.getToken()}` }
      };
    }
    else {
      config.headers = { Authorization: `Bearer ${JwtService.getToken()}` };
    }
    return Vue.axios.get(
      `${this.baseUrl + resource + "?" + qs.stringify(params)}`,
      config
    );
    // return Vue.axios
    //   .get(`${this.baseUrl + resource}`, qs.stringify(params), {
    //     headers: { Authorization: `Bearer ${JwtService.getToken()}` }
    //   })
    //   .catch(error => {
    //     // console.log(error);
    //     throw new Error(`[KT] ApiService ${error}`);
    //   });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params, config = null) {
    //console.log("post:", resource, params);
    if (!config) {
      config = {
        headers: { Authorization: `Bearer ${JwtService.getToken()}` }
      };
    }
    return Vue.axios.post(`${this.baseUrl + resource}`, params, config);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${this.baseUrl + resource}/${slug}`, params, {
      headers: { Authorization: `Bearer ${JwtService.getToken()}` }
    });
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${this.baseUrl + resource}`, params, {
      headers: { Authorization: `Bearer ${JwtService.getToken()}` }
    });
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios
      .delete(this.baseUrl + resource, {
        headers: { Authorization: `Bearer ${JwtService.getToken()}` }
      })
      .catch(error => {
        // console.log(error);
        throw new Error(`[RWV] ApiService ${error}`);
      });
  },

  upload(resource, data) {
    return Vue.axios.put(`${this.baseUrl + resource}`, data, {
      headers: {
        Authorization: `Bearer ${JwtService.getToken()}`,
        "Content-Type": "multipart-form-data"
      }
    });
  }
};

export default ApiService;
